<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  selectedCount: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['cancel', 'forward']);

const { t } = useI18n();

const canForward = computed(() => props.selectedCount > 0);
</script>

<template>
  <div
    class="sticky top-0 z-50 bg-woot-500 dark:bg-woot-600 text-white shadow-md border-b border-woot-600 dark:border-woot-700 transition-all duration-200"
  >
    <div class="flex items-center justify-between px-4 py-2.5">
      <div class="flex items-center gap-3">
        <button
          type="button"
          class="p-1 rounded-md hover:bg-white/10 transition-colors"
          :aria-label="t('GENERAL.CLOSE')"
          @click="emit('cancel')"
        >
          <i class="i-lucide-x w-5 h-5" />
        </button>
        <span class="text-sm font-medium">
          {{ t('MESSAGE_SELECTION.COUNT', { count: selectedCount }) }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="px-3 py-1.5 text-sm font-medium rounded-lg bg-white text-woot-600 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center gap-1.5"
          :disabled="!canForward"
          @click="emit('forward')"
        >
          <i class="i-lucide-share w-4 h-4" />
          {{ t('FORWARD_MODAL.SUBMIT') }}
        </button>
      </div>
    </div>
  </div>
</template>
